
import { inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (values?.dynamicPopularLocation) {
    let dynamicPopularLocationError = [];
    values.dynamicPopularLocation.map((item, index) => {
      const dynamicNameError = {};
      if (!item?.language || item?.language.toString().trim() === '') {
        dynamicNameError.language = messages.required;
        dynamicPopularLocationError[index] = dynamicNameError;
      }

      if (!item?.location || item?.location.toString().trim() === '') {
        dynamicNameError.location = messages.required;
        dynamicPopularLocationError[index] = dynamicNameError;
      } else if (item?.location?.length > inputTextLimit) {
        dynamicNameError.location = messages.inputTextLimitError;
        dynamicPopularLocationError[index] = dynamicNameError;
      }
    });
    if (dynamicPopularLocationError?.length > 0) errors.dynamicPopularLocation = dynamicPopularLocationError;
  }

  if (!values.locationAddress) {
    errors.locationAddress = messages.required;
  } else if (values.locationAddress.trim() == "") {
    errors.locationAddress = messages.blankSpace;
  }

  return errors
}

export default validate
